import React from 'react';
import StoryCard from './StoryCard';
import { BlueLink } from '../../buttons';

const StoriesBox = ({ title, more, stories, onMore, className }) => (
  <div className={`stories ${className}`}>
    <p className="f--2 lh-copy t-mb1 near-black">
      {title}
      <span className="t-pl3">
        <BlueLink text={more} onClick={onMore} />
      </span>
    </p>
    <div className="flex flex-wrap justify-start ">
      { stories.map((story, i) => <StoryCard key={i} {...story} />) }
    </div>
  </div>
);

StoriesBox.defaultProps = {
  className: '',
  stories: [{}, {}, {}]
};

const AuthorStories = props => (
  <StoriesBox className="t-mr0 t-mr3-m t-mb3" {...props} />
);

AuthorStories.defaultProps = {
  stories: [{}, {}, {}]
};

const GenreStories = props => (
  <StoriesBox {...props} />
);

GenreStories.defaultProps = {
  stories: [{}, {}]
};


export default StoriesBox;
export { AuthorStories, GenreStories };
